import React, { useState } from "react";
import Header from "./layers/Header";
import Footer from "./layers/Footer";

const ContactUs = () => {
  const [showContacts, setShowContacts] = useState(false);

  const email = "cjfrancisf@gmail.com";
  const phone = "+2349160340807";
  const whatsapp = "+2348077417209";

  return (
    <>
      <Header />

      <section className="bg-white py-20">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h1 className="text-4xl font-bold text-[#1E0E62] mb-6">Contact Us</h1>
          <p className="text-lg text-[#1E0E62]/70 mb-8">
            Reach out to us for support, partnerships, or any inquiries.
          </p>

          <button
            className="bg-[#25DAC5] text-white px-8 py-3 rounded-full font-semibold shadow-md hover:bg-[#1E0E62] transition mb-6"
            onClick={() => setShowContacts(!showContacts)}
          >
            {showContacts ? "Hide Contact Info" : "Show Contact Info"}
          </button>

          {showContacts && (
            <div className="mt-6 space-y-4 text-[#1E0E62]/90 text-lg">
              <p>Email: <a href={`mailto:${email}`} className="underline">{email}</a></p>
              <p>Phone: <a href={`tel:${phone}`} className="underline">{phone}</a></p>
              <p>
                WhatsApp:{" "}
                <a
                  href={`https://wa.me/${whatsapp.replace(/\+/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="underline"
                >
                  {whatsapp}
                </a>
              </p>
            </div>
          )}
        </div>
      </section>

      <Footer />
    </>
  );
};

export default ContactUs;